"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInputChoiceImageField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class UserInputChoiceImageField extends EditorFieldBase_1.EditorFieldBase {
}
exports.UserInputChoiceImageField = UserInputChoiceImageField;
